import React from 'react';
import {Field} from 'formik';
import {
    TextField,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";


function PrestationDataField({...props}) {
    const {values, errors, handleChange, handleBlur} = props;


    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/*LIBELLE FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.libelle}>
                        {({field, form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.libelle && form.touched.libelle)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                autoFocus
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }/>
                        )}
                    </Field>
                </Grid>
            </Grid>

        </Grid>
    );
}

export default PrestationDataField;
